import { Component, EventEmitter, Output, Input } from '@angular/core';
import { AgendaModelV3, AgendaEvent, QueovalDateTime, SelectedEvent, AgendaCol, AgendaRow } from '../../../models';
import { QueovalDateService, CoreService, HttpService } from '../../../services';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastService } from '../../../toast';

@Component({
  // tslint:disable-next-line:component-selector
  selector: 'q-affiche-month-v3',
  templateUrl: './affiche.month.component.html',
  styleUrls: ['./affiche.month.component.css', '../affiche.component.css']
})
// Affiche la grille du calendrier
export class AfficheMonthComponentV3 {

  public boolDataNeedToBeUpdated: boolean;
  public displayPopover: boolean = true;

  public rdvSelected: Array<AgendaEvent>;
  public daySelected: string;
  public dayNumberSelected: number;

  public dragStart: boolean = false;
  public dragColId: number;
  public dragRowId: number;
  public contextEvent: AgendaEvent | null;

  private elementDragged: AgendaEvent;

  private isUpdate: boolean = false;

  @Input() model: AgendaModelV3;
  @Output('modelChange') modelChange: EventEmitter<AgendaModelV3> = new EventEmitter<AgendaModelV3>(true);

  @Output('openEvent') openEvent: EventEmitter<AgendaEvent> = new EventEmitter<AgendaEvent>(true);
  @Output('newEvent') newEvent: EventEmitter<QueovalDateTime> = new EventEmitter<QueovalDateTime>(true);
  @Output('updateEvent') updateEvent: EventEmitter<AgendaEvent> = new EventEmitter<AgendaEvent>(true);
  @Output('loading') loading: EventEmitter<boolean> = new EventEmitter<boolean>(true);


  constructor(
    private http: HttpService,
    protected toastService: ToastService,
    public indParam: CoreService,
    protected qdate: QueovalDateService,
    private modalService: NgbModal
  ) { }

  // #region Useless méthodes
  public CompareDates(i: number):boolean {
    return this.qdate.Compare(this.qdate.Now(), '=', this.model.listCalendars[0].body.startDate, i, 'days');
  }

  public startDateYear(startDate: QueovalDateTime, endDate: QueovalDateTime): string {
    return Number.parseInt(startDate.annee) === Number.parseInt(endDate.annee) ? '' : startDate.annee;
  }

  public EmitEvent(event: AgendaEvent): void {
    this.isUpdate = true;
    if (event.isReadable || event.isUpdatable) {
      this.modalService.dismissAll();
      this.openEvent.emit(event);
    }
    setTimeout(() => {
      this.isUpdate = false;
    }, 500);
  }

  public OpenModal(daysToAdd: number): void {
    setTimeout(() => {
      if (!this.isUpdate) {
        const date: Date = this.qdate.ToDate(this.model.listCalendars[0].body.startDate) as Date;
        date.setDate(date.getDate() + daysToAdd);
        this.newEvent.emit(this.qdate.FromDateTime(date));
      }
    }, 0);
  }

  public AfficheAllEvents(content: any, events: Array<AgendaEvent>, daysToAdd: number): void {
    this.isUpdate = true;
    const date: Date = this.qdate.ToDate(this.model.listCalendars[0].body.startDate) as Date;
    date.setDate(date.getDate() + daysToAdd);
    this.rdvSelected = events;

    const options = { weekday: 'long' } as Intl.DateTimeFormatOptions;
    this.daySelected = new Intl.DateTimeFormat(this.indParam.AppParams.culture, options).format(date);
    this.dayNumberSelected = date.getDate();
    this.modalService.open(content, { backdrop: 'static', centered: true });
    setTimeout(() => {
      this.isUpdate = false;
    }, 500);
  }

  //#region drag & drop
  public allowDrop(ev: any, icol: number, irow: number): void {
      this.dragRowId = irow;
      this.dragColId = icol;
      ev.preventDefault();
  }

  public dragEvent(event: AgendaEvent): void {
    this.dragStart = true;
    this.elementDragged = event;
  }
  public DisableDrop(ev: any): void {
    ev.stopPropagation();
  }

  public DragEnd(): void {
    this.dragStart = false;
  }

  public onDrop(e: any, dayIndex: number): void {
    //#region construction du model
    const model: AgendaModelV3 = JSON.parse(JSON.stringify(this.model));
    model.Mode = 'UPDATE_DATE';
    model.selectedEvent = new SelectedEvent();
    model.selectedEvent.pEvent = this.elementDragged;
    let startDate: Date | null = this.qdate.ToDate(this.model.listCalendars[0].body.startDate);
    if (startDate) {
      startDate.setDate(startDate.getDate() + dayIndex);
    }

    model.selectedEvent.pEvent.startDate = this.qdate.FromDateTime(startDate);
      model.selectedEvent.pEvent.startDate.heures = '';
      model.selectedEvent.pEvent.startDate.minutes = '';

    //#endregion
    if (this.elementDragged.isUpdatable) {
      this.loading.emit(true);
      this.http.postHttp<AgendaModelV3>(`${this.indParam.AppParams.apiUrl}api/agenda/v3/`, model).subscribe(
        (result: AgendaModelV3) => {
          this.loading.emit(false);
          if (result.Mode) {
            this.model = result;
          }
          this.modelChange.emit(this.model);
        })
    } else {
      this.toastService.showAlertToast('vous ne disposez pas des droits nécessaires');
    }
  }


  public trackWeeklyRows(index: number, item: AgendaRow) {
    return item.id;
  }
  public trackWeeklyCols(index: number, item: AgendaCol) {
    return item.id;
  }
  public trackWeeklyEvents(index: number, item: AgendaEvent) {
    return item.ident;
  }
  // #endregion

  // #endregion
}
